module.exports = __webpack_public_path__ + "static/chooseDrama-125d55bf557692315d590d742d68fbc9.jpg";